import TrendingService from "../../services/TrendingService";

export const GET_TRENDING_REQUEST = "GET_TRENDING_REQUEST";
export const GET_TRENDING_SUCCESS = "GET_TRENDING_SUCCESS";
export const GET_TRENDING_ERROR = "GET_TRENDING_ERROR";

export const getTrendingEvents = locale => {
  return dispatch => {
    dispatch({ type: GET_TRENDING_REQUEST });
    TrendingService.getTrendingEvents(locale)
      .then(res => {
        dispatch({
          type: GET_TRENDING_SUCCESS,
          trendingEvents: res
        });
      })
      .catch(err => {
        dispatch({ type: GET_TRENDING_ERROR, error: err });
      });
  };
};
